
import { UntypedFormControl } from '@angular/forms';
import { Rule } from "ngx-angular-query-builder";

export function containsUppercase(control: UntypedFormControl) {
  let regex = new RegExp('([A-Z])');
  let result = regex.test(control.value);
  if (!result) {
    return {
      containsUppercase: {
        message: 'This control does not contain an uppercase character'
      }
    }
  }
  return null;
}

export function validateFilter(control: UntypedFormControl) {
  const errors: string[] = [];
  for (let ruleItem of control.value.rules) {
    const rule = ruleItem as Rule;
    if (!rule.hasOwnProperty('value') || rule.value === 'unselected') {
      errors.push(rule.field);
    }
  }
  if (errors.length > 0) {
    return {
      validateFilter: {
        message: "Please ensure a valid filter option has been selected"
      }
    }
  }
  return null;
}



export function containsLowercase(control: UntypedFormControl) {
  let regex = new RegExp('([a-z])');
  let result = regex.test(control.value);
  if (!result) {
    return {
      containsLowercase: {
        message: 'This control does not contain an lowercase character'
      }
    }
  }
  return null;
}

export function containsDigit(control: UntypedFormControl) {
  let regex = new RegExp('[0-9]');
  let result = regex.test(control.value);
  if (!result) {
    return {
      containsDigit: {
        message: 'This control does not contain a digit character'
      }
    }
  }
  return null;
}

export function containsSymbol(control: UntypedFormControl) {
  let regex = new RegExp('[^a-zA-Z0-9\s:]');
  let result = regex.test(control.value);
  if (!result) {
    return {
      containsSymbol: {
        message: 'This control does not contain a symbol character'
      }
    }
  }
  return null;
}
